/** Google Picker: el usuario elige su libro una vez; con drive.file la app solo accede a ese fichero. */
import type { ClientConfig } from './api-client.js';

declare global { interface Window { gapi?: any; google?: any } }

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve();
    const s = document.createElement('script');
    s.src = src; s.async = true; s.onload = () => resolve(); s.onerror = () => reject(new Error('No se pudo cargar Google Picker'));
    document.head.appendChild(s);
  });
}

export async function pickSpreadsheet(cfg: ClientConfig, accessToken: string, title: string): Promise<{ id: string; name: string } | null> {
  await loadScript('https://apis.google.com/js/api.js');
  await new Promise<void>(resolve => window.gapi.load('picker', () => resolve()));
  const g = window.google;
  return new Promise(resolve => {
    const view = new g.picker.DocsView(g.picker.ViewId.SPREADSHEETS).setMode(g.picker.DocsViewMode.LIST).setIncludeFolders(true);
    new g.picker.PickerBuilder()
      .setTitle(title).addView(view).setOAuthToken(accessToken).setDeveloperKey(cfg.pickerApiKey).setAppId(cfg.projectNumber)
      .setLocale('es').setCallback((data: any) => {
        if (data.action === g.picker.Action.PICKED) resolve({ id: data.docs[0].id, name: data.docs[0].name });
        else if (data.action === g.picker.Action.CANCEL) resolve(null);
      }).build().setVisible(true);
  });
}
